function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from "@material-ui/core/Input";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { clearCategoriesEpgs, clearSearch, filterByCategory, getLastWatchedEpgs, getMostWatchedEpgs, getRecordedCategories, resetVideo, toggleVideoPlayerState } from "@common/actions";
import { isMobile } from "@common/services/helpers";
import { DEFAULT_LOGGED_ROUTE, FILTER_TYPE_LIVE, HEADER_CLOCK_ENABLED, HEADER_ROUTES, KEY_ENTER, KEY_SPACE, LARGE_MOBILE_TYPE_PX, LOGO_SITE_MOBILE, LOGO_SITE_WEB, MOBILE_TYPE_PX, MOST_WATCHED, ROUTE_LIVE, ROUTE_ON_RECORD, ROUTE_ORDER, ROUTE_SEARCH, SEARCH_MODES, TABLET_TYPE_PX, TOOLTIP_SHOW_DELAY, VOD, WEB_TYPE_PX } from "@config/constants";
import HelpMenu from "@common/components/Header/helpMenu";
import SearchBar from "@common/components/SearchBar";
import Time from "@common/components/Time";
// Components
import AccountMenu from "@common/components/account/AccountMenu";
import OrderHeader from "@common/components/order/OrderHeader";
import PromoIcon from "@components/PromoIcon";
var Header = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Header, Component);
    var _super = _create_super(Header);
    function Header(props) {
        _class_call_check(this, Header);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isSearchOnFocus: false,
            isSearchVisible: false,
            searchString: ""
        };
        _this.closePlayer = _this.closePlayer.bind(_assert_this_initialized(_this));
        _this.handleEnterKeyPressed = _this.handleEnterKeyPressed.bind(_assert_this_initialized(_this));
        _this.hideMainNavigation = _this.hideMainNavigation.bind(_assert_this_initialized(_this));
        _this.onSearchChange = _this.onSearchChange.bind(_assert_this_initialized(_this));
        _this.redirectToSearchFromKeyboard = _this.redirectToSearchFromKeyboard.bind(_assert_this_initialized(_this));
        _this.redirectToSearchPage = _this.redirectToSearchPage.bind(_assert_this_initialized(_this));
        _this.removeSearchFocus = _this.removeSearchFocus.bind(_assert_this_initialized(_this));
        _this.setSearchFocus = _this.setSearchFocus.bind(_assert_this_initialized(_this));
        _this.showMainNavigation = _this.showMainNavigation.bind(_assert_this_initialized(_this));
        _this.stopPlayer = _this.stopPlayer.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(Header, [
        {
            /**
     * Controls search input value
     * @param event
     */ key: "onSearchChange",
            value: function onSearchChange(event) {
                var newSearchValue = event.target.value;
                this.setState({
                    searchString: newSearchValue
                });
            }
        },
        {
            /**
     * Handles enter key pressed
     * @param event
     */ key: "handleEnterKeyPressed",
            value: function handleEnterKeyPressed(event) {
                var key = event.which;
                if (key === KEY_ENTER) {
                    this.redirectToSearchPage();
                }
            }
        },
        {
            /**
     * Redirects to search page
     * with search value and clears it
     */ key: "redirectToSearchPage",
            value: function redirectToSearchPage() {
                var history = this.props.history;
                var searchString = this.state.searchString;
                this.setState({
                    searchString: ""
                });
                this.removeSearchFocus();
                if (location.pathname !== ROUTE_SEARCH) {
                    history.push("".concat(ROUTE_SEARCH, "?query=").concat(searchString, "&mode=").concat(SEARCH_MODES[0].id));
                }
            }
        },
        {
            /**
     * Redirects to search page on enter/space key press
     * @param event {Object}
     */ key: "redirectToSearchFromKeyboard",
            value: function redirectToSearchFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.redirectToSearchPage();
                }
            }
        },
        {
            /**
     * Sets search input on focus
     * so that main navigation remains hidden
     */ key: "setSearchFocus",
            value: function setSearchFocus() {
                this.setState({
                    isSearchOnFocus: true
                }, this.hideMainNavigation);
            }
        },
        {
            /**
     * Set search input out of focus
     * so that main navigation shows
     */ key: "removeSearchFocus",
            value: function removeSearchFocus() {
                this.setState({
                    isSearchOnFocus: false
                }, this.showMainNavigation);
            }
        },
        {
            /**
     * Renders the search bar if the
     * pathname matches the search route.
     * @returns {ReactElement || null}
     */ key: "renderSearchBar",
            value: function renderSearchBar() {
                var _this_props = this.props, i18n = _this_props.i18n, location1 = _this_props.location, toggleCategoryFilter = _this_props.toggleCategoryFilter, closeCategoryFilter = _this_props.closeCategoryFilter, isCategoriesFilterOpen = _this_props.isCategoriesFilterOpen;
                return location1.pathname === ROUTE_SEARCH ? /*#__PURE__*/ _jsx(SearchBar, {
                    i18n: i18n,
                    isCategoriesFilterOpen: isCategoriesFilterOpen,
                    closeCategoryFilter: closeCategoryFilter,
                    toggleCategoryFilter: toggleCategoryFilter,
                    playerIsOpen: this.props.videoPlayer.isOpen && !isMobile.any()
                }) : null;
            }
        },
        {
            /**
     * Hides main navigation
     * and opens search
     * when width is between 1024px and 1366px
     */ key: "hideMainNavigation",
            value: function hideMainNavigation() {
                var windowWidth = window.innerWidth;
                if (windowWidth > TABLET_TYPE_PX && windowWidth < WEB_TYPE_PX) {
                    this.setState({
                        isSearchVisible: true
                    });
                }
            }
        },
        {
            /**
     * Shows main navigation
     * and hides search
     * when search input is not on focus
     */ key: "showMainNavigation",
            value: function showMainNavigation() {
                if (!this.state.isSearchOnFocus) {
                    this.setState({
                        isSearchVisible: false
                    });
                }
            }
        },
        {
            /**
     * Closes player container
     */ key: "closePlayer",
            value: function closePlayer() {
                if (this.props.videoPlayer.isOpen && !isMobile.any()) {
                    this.props.toggleVideoPlayerState({
                        isOpen: false,
                        isPlaying: true
                    });
                }
            }
        },
        {
            /**
     * Stopping player on logo click
     * @param event
     */ key: "stopPlayer",
            value: function stopPlayer(event) {
                event.stopPropagation();
                this.props.getLiveChannels();
                this.props.clearSearch(true);
                this.props.filterByCategory(null, FILTER_TYPE_LIVE);
                if (this.props.videoPlayer.isPlaying) {
                    this.props.resetVideo();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                ReactTooltip.rebuild();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var template = null;
                var _this_props = this.props, location1 = _this_props.location, i18n = _this_props.i18n, screenType = _this_props.screenType, videoPlayer = _this_props.videoPlayer, header = _this_props.header, isScreenLandscape = _this_props.isScreenLandscape, serverTime = _this_props.serverTime, setMenuFlag = _this_props.setMenuFlag, getLiveChannels = _this_props.getLiveChannels, showingPlace = _this_props.showingPlace;
                var _this_state = this.state, isSearchVisible = _this_state.isSearchVisible, searchString = _this_state.searchString;
                var mainNavigationClass = isSearchVisible ? " invisible" : "";
                var searchInputClass = isSearchVisible ? " shown" : "";
                var logo = screenType.smallMobile ? LOGO_SITE_MOBILE : LOGO_SITE_WEB;
                var isSearchPage = location1.pathname === ROUTE_SEARCH;
                var headerClasses = "header-wrapper";
                headerClasses += videoPlayer.isOpen && (!isMobile.any() && window.innerWidth >= MOBILE_TYPE_PX || isMobile.any() && (window.innerWidth >= LARGE_MOBILE_TYPE_PX || window.innerWidth >= MOBILE_TYPE_PX && !isScreenLandscape)) ? " opened-player" : "";
                headerClasses += header.isHidden && videoPlayer.isOpen ? " hidden" : "";
                var _obj;
                var navbarMap = (_obj = {}, _define_property(_obj, ROUTE_LIVE, {
                    title: i18n.live,
                    onClick: getLiveChannels
                }), _define_property(_obj, MOST_WATCHED, {
                    title: i18n.mostWatched,
                    onClick: function() {
                        _this.props.getLastWatchedEpgs();
                        _this.props.getMostWatchedEpgs();
                    }
                }), _define_property(_obj, ROUTE_ON_RECORD, {
                    title: i18n.onRecord,
                    onClick: function() {
                        // Need to be sure that the previous epgs
                        // are cleared. Because they load in
                        // async way, it's possible to leave this
                        // route before all are loaded, so on reentering
                        // we might have an old category that for
                        // some reason should not be displayed, so
                        // we make sure that the state is cleaned before
                        // the new categories arrive.
                        _this.props.clearCategoriesEpgs();
                        _this.props.getRecordedCategories();
                    }
                }), _define_property(_obj, VOD, {
                    title: i18n.vod,
                    onClick: function() {
                        // Need to be sure that the previous epgs
                        // are cleared. Because they load in
                        // async way, it's possible to leave this
                        // route before all are loaded, so on reentering
                        // we might have an old category that for
                        // some reason should not be displayed, so
                        // we make sure that the state is cleaned before
                        // the new categories arrive.
                        _this.props.clearCategoriesEpgs();
                        _this.props.getRecordedCategories(true);
                    }
                }), _obj);
                if (location1.pathname.search(ROUTE_ORDER) >= 0) {
                    template = /*#__PURE__*/ _jsx(OrderHeader, {
                        i18n: i18n,
                        screenType: screenType
                    });
                } else if (location1.pathname.search(ROUTE_ORDER) < 0) {
                    template = /*#__PURE__*/ _jsxs("div", {
                        className: headerClasses,
                        onClick: this.closePlayer,
                        children: [
                            /*#__PURE__*/ _jsxs("header", {
                                children: [
                                    /*#__PURE__*/ _jsx(ReactTooltip, {
                                        disable: !screenType.web,
                                        effect: "solid",
                                        place: "bottom",
                                        delayShow: TOOLTIP_SHOW_DELAY,
                                        className: "tooltip",
                                        id: "header-tooltip"
                                    }),
                                    /*#__PURE__*/ _jsx(NavLink, {
                                        to: DEFAULT_LOGGED_ROUTE,
                                        className: "logo logo-header",
                                        onClick: this.stopPlayer,
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: logo,
                                            alt: "logo",
                                            "aria-hidden": true
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(PromoIcon, {
                                        userDetails: this.props.userDetails
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "main-navigation".concat(mainNavigationClass),
                                        children: HEADER_ROUTES.filter(function(param) {
                                            var enabled = param.enabled;
                                            return enabled;
                                        }).map(function(param) {
                                            var route = param.route;
                                            var item = navbarMap[route];
                                            return /*#__PURE__*/ _jsx(NavLink, {
                                                to: route,
                                                activeClassName: "selected",
                                                onClick: item.onClick,
                                                "aria-label": item.title,
                                                children: item.title
                                            }, route);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "sub-navigation",
                                        children: [
                                            screenType.web && !isSearchPage ? /*#__PURE__*/ _jsxs("div", {
                                                className: "search-input-container",
                                                onMouseEnter: this.hideMainNavigation,
                                                onMouseLeave: this.showMainNavigation,
                                                children: [
                                                    /*#__PURE__*/ _jsx(Input, {
                                                        onChange: this.onSearchChange,
                                                        onKeyPress: this.handleEnterKeyPressed,
                                                        onFocus: this.setSearchFocus,
                                                        onBlur: this.removeSearchFocus,
                                                        type: "text",
                                                        className: "ux-input search-input".concat(searchInputClass),
                                                        value: searchString,
                                                        placeholder: i18n.search.placeholderShort
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "icon icon-search",
                                                        tabIndex: "0",
                                                        "data-for": "header-tooltip",
                                                        "data-tip": i18n.common.search,
                                                        onKeyDown: this.redirectToSearchFromKeyboard,
                                                        onClick: this.redirectToSearchPage
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ _jsx("span", {
                                                className: "search-icon-wrapper".concat(isSearchPage ? " active" : ""),
                                                onKeyDown: this.redirectToSearchFromKeyboard,
                                                onClick: this.redirectToSearchPage,
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    tabIndex: "0",
                                                    "data-tip": i18n.common.search,
                                                    "data-for": "header-tooltip",
                                                    className: "icon icon-search"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(HelpMenu, {
                                                setMenuFlag: setMenuFlag
                                            }),
                                            /*#__PURE__*/ _jsx(AccountMenu, {
                                                setMenuFlag: setMenuFlag
                                            })
                                        ]
                                    }),
                                    HEADER_CLOCK_ENABLED && serverTime ? /*#__PURE__*/ _jsx(Time, {
                                        serverTime: serverTime,
                                        city: showingPlace ? showingPlace : i18n.sofia
                                    }) : null
                                ]
                            }),
                            this.renderSearchBar()
                        ]
                    });
                }
                return template;
            }
        }
    ]);
    return Header;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, currentChannel = param.currentChannel, videoPlayer = param.videoPlayer, liveChannels = param.liveChannels, screenType = param.screenType, searchState = param.searchState, header = param.header;
    return {
        i18n: i18n,
        currentChannel: currentChannel,
        videoPlayer: videoPlayer,
        liveChannels: liveChannels,
        screenType: screenType,
        searchState: searchState,
        header: header
    };
};
// Promote App from a component to a container - it needs to know
// about this new dispatch method, getTranslations. Make it available as a prop.
export default withRouter(connect(mapStateToProps, {
    resetVideo: resetVideo,
    toggleVideoPlayerState: toggleVideoPlayerState,
    clearSearch: clearSearch,
    getLastWatchedEpgs: getLastWatchedEpgs,
    getMostWatchedEpgs: getMostWatchedEpgs,
    clearCategoriesEpgs: clearCategoriesEpgs,
    getRecordedCategories: getRecordedCategories,
    filterByCategory: filterByCategory
})(Header));
